import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Agendamento } from "../../../../services/Agendamento";
import { IVeiculoForm } from "../../../../types/veiculo";

export const useVincularVeiculoPrimeiroRegistro = () => {
  return useMutation({
    mutationFn: ({
      uuidAgendamento,
      veiculoForm,
    }: {
      uuidAgendamento: string;
      veiculoForm: IVeiculoForm;
    }) => Agendamento.vincularVeiculoPrimeiroRegistro({ uuidAgendamento, veiculoForm }),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
